module.exports = __webpack_public_path__ + "static/media/135U3_Bathroom.bd53fabe.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/GalleryPhotos/135U3_Bathroom.jpg
// module id = 539
// module chunks = 0